import { render, staticRenderFns } from "./SetEmailNotification.vue?vue&type=template&id=175a9e36&scoped=true"
import script from "./SetEmailNotification.vue?vue&type=script&lang=ts"
export * from "./SetEmailNotification.vue?vue&type=script&lang=ts"
import style0 from "./SetEmailNotification.vue?vue&type=style&index=0&id=175a9e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a9e36",
  null
  
)

export default component.exports